module.exports = __webpack_public_path__ + "img/icon-doc.3eadb0d3.png";